import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Modal from "@/components/rebrand/modal/modal";
import ButtonLink from "@/components/common/buttonLink/ButtonLink";
import { RideIcSoatLight } from "@rimac-seguros/ride-system-components";
import DynamicIcon from "../../../../../components/atoms/DynamicIcon/index";

const CardPurchase = (props) => {
  const {
    soat,
    oneStepData,
    afterText,
    mainTitlesCard,
    listtBenefits,
    title,
    oneStep,
  } = props;

  const [titleMain, setTitleMain] = useState("");
  const [beforeText, setBeforeText] = useState("");

  const isLoadedOneStep = !oneStepData.isLoading;
  const isActionUserOneStep = oneStepData.isActionUser;
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (soat && mainTitlesCard) {
      mainTitlesCard.forEach((item) => {
        if (item.key === soat) {
          setTitleMain(item.title);
          setBeforeText(item.beforeText);
        }
      });
    }
  }, [soat]);

  useEffect(() => {
    if (oneStep) {
      if (isActionUserOneStep && !isLoadedOneStep) {
        setShowModal(true);
      } else {
        setShowModal(false);
      }
    }
  }, [oneStep, isLoadedOneStep, isActionUserOneStep]);

  return (
    <>
      <div className="card-purchase__content">
        {beforeText && <p className="card-purchase__text v1">{beforeText}</p>}

        <div className="card-purchase__wrapperTitle">
          <h4
            className="card-purchase__title"
            dangerouslySetInnerHTML={{ __html: titleMain || title }}
          />
          <RideIcSoatLight size="large" />
        </div>

        {afterText && (
          <p
            className="card-purchase__text v2"
            dangerouslySetInnerHTML={{ __html: afterText }}
          />
        )}

        {listtBenefits && (
          <div className="card-purchase__coverage">
            <div className="container-section">
              {listtBenefits.map((item, index) => (
                <div className="container-section__row coverage" key={index}>
                  <DynamicIcon icon={item.imagen} />
                  <div className="container-section__text">
                    {item.description}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="card-purchase__button">
          <ButtonLink {...props} />
        </div>

        {showModal && (
          <Modal
            active={true}
            onClose={() => setShowModal(false)}
            title={"Estamos preparando tu cotización"}
            classModal={`modal-consulta-soat__${"cssName"}`}
            body={
              <>
                <p>{"Estamos preparando tu cotización"}</p>
                <div>
                  <button className="btn__primary" onClick={() => {}}>
                    <div id="circle3"></div>
                  </button>
                </div>
              </>
            }
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({ consultReducer, oneStepReducer }) => {
  return {
    soat: consultReducer?.statusSOAT || "",
    oneStepData: oneStepReducer,
  };
};

const mapDsipatchToProps = (dispatch) => {};

const cardPurchaseR = connect(
  mapStateToProps,
  mapDsipatchToProps
)(CardPurchase);

export default cardPurchaseR;
